import color from 'utils/color';

export const skill1 = [
  { id: 1, percent: 100, title: 'Web Design', color: color.violet },
  { id: 2, percent: 80, title: 'Mobile Design', color: color.blue },
  { id: 3, percent: 85, title: 'Development', color: color.leaf },
  { id: 4, percent: 90, title: 'SEO', color: color.pink }
];

// used in the about-24 block
export const skill2 = [
  { id: 1, title: 'Photoshop', value: 100 },
  { id: 2, title: 'Final Cut', value: 80 },
  { id: 3, title: 'Motion Video', value: 85 },
  { id: 4, title: 'Manupilation', value: 75 }
];
